import Hero from '../components/Hero';
import SpiceShowcase from '../components/SpiceShowcase';
import StoryBand from '../components/StoryBand';
import ProcessStory from '../components/ProcessStory';
import RaginiPromises from '../components/RaginiPromises';
import KitchenMoments from '../components/KitchenMoments';
import CinematicBanner from '../components/CinematicBanner';
import Testimonials from '../components/Testimonials';
import DishesSection from '../components/DishesSection';

const Home = () => {
  return (
    <main>
      <Hero />
      <SpiceShowcase />
      <StoryBand />
      <ProcessStory />
      <RaginiPromises />
      <KitchenMoments />
      <DishesSection title="Signature Recipes" subtitle="Discover the authentic flavors of India through our curated collection" />
      <CinematicBanner />
      <Testimonials />
    </main>
  );
};

export default Home;
